import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseUtils } from '../../shared/core/baseUtils.service';
@Component({
  selector: 'ba-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PageNotFoundComponent implements OnInit {
  errorStatus: any;
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public baseUtils: BaseUtils
  ) { }

  ngOnInit() {
    this.errorStatus = +this.activatedRoute.snapshot.queryParamMap.get('status');
  }

  /**
   * If user clicks on Take me home button he will be redirected to location items if he is logged in,
   * else it will redirect to login page
   */
  redirectToMainPage() {
    if (localStorage.getItem('loggedInUser')) {
      this.getCurrentRoute();
    } else {
      this.router.navigate(['login']);
    }
  }

  /**
   * To get current route
   */
  getCurrentRoute() {
    const permissions = JSON.parse(localStorage.getItem('loggedInUser'));
    const role = permissions.role;
    const accessGroup = permissions.accessGroupPermissions;

    if (role === "Super Admin" || role === "Support Admin") {
      this.router.navigate(['/sales/locationItems']);
    }
    else if (accessGroup.length) {
      switch (true) {
        case accessGroup.includes('Sales Access Group'):
          this.router.navigate(['/sales/locationItems'])
          break;
        case accessGroup.includes('Data Point Reporting Access Group'):
          this.router.navigate(['/data-point-reporting/store/overview']);
          break;
        case accessGroup.includes('Sheets Access Group'):
          this.router.navigate(['sheets']);
          break;
        case accessGroup.includes('Balancing Access Group'):
          this.router.navigate(['/balancing/dashboard']);
          break;
        case accessGroup.includes('POS Reports Access Group'):
          this.router.navigate(['reports']);
          break;
        case accessGroup.includes('Cashiers Access Group'):
          this.router.navigate(['cashiers']);
          break;
        case accessGroup.includes('Transactions Access Group'):
          this.router.navigate(['transactions']);
          break;
        case accessGroup.includes('Custom Reports Access Group'):
          this.router.navigate(['/custom-report/tax-report']);
          break;
        case accessGroup.includes('Analytics Access Group'):
          this.router.navigate(['/analytics/query']);
          break;
        case accessGroup.includes('Company Setting'):
          this.router.navigate(['/settings/companies']);
          break;
        case accessGroup.includes('Datapoint Setting'):
          this.router.navigate(['/settings/dp-category']);
          break;
        case accessGroup.includes('Location Setting'):
          this.router.navigate(['/settings/locations']);
          break;
        case accessGroup.includes('Department Setting'):
          this.router.navigate(['settings/departments-mapping']);
          break;
        case accessGroup.includes('Users Setting'):
          this.router.navigate(['/settings/users']);
          break;
        case accessGroup.includes('Connector Setting'):
          this.router.navigate(['/settings/connectors']);
          break;
        case accessGroup.includes('Calendar Period Setting'):
          this.router.navigate(['/settings/calendar-period']);
          break;
        case accessGroup.includes('Instacart Setting'):
          this.router.navigate(['/settings/instacart']);
          break;
        default:
          this.baseUtils.toasterMessageAction('error', 'User does not have any permissions');
      }
    }
    else {
      localStorage.removeItem('loggedInUser');
      this.baseUtils.toasterMessageAction('error', 'User does not have any permissions');
    }
  }
}